// src/components/UserDashboard/HeaderComponent.js - FIXED LANGUAGE CALLBACK
import React from 'react';
// import { useNavigate } from 'react-router-dom';
import ProfileMenu from './ProfileMenu';
import NotificationDropdown from '../Notification/NotificationDropdown';
import '../Notification/NotificationDropdown.css';

const HeaderComponent = ({
  user,
  searchTerm,
  setSearchTerm,
  handleSearch,
  showProfileMenu,
  setShowProfileMenu,
  profileMenuRef,
  requestPending,
  handleArtistRequest,
  handleVenueOwnerRequest,
  handleLogout,
  navigate,
  language = 'th',
  onLanguageChange,
  onBack, // overlay close callback — when provided, ← uses this instead of browser history
}) => {
  const translations = {
    th: {
      search: 'ค้นหา',
      groupTracking: 'ติดตามกลุ่ม'
    },
    en: {
      search: 'Search',
      groupTracking: 'Group Tracking'
    },
    zh: {
      search: '搜索',
      groupTracking: '群组跟踪'
    }
  };

  const t = translations[language];

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    if (window.history.length <= 1) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  return (
    <header className="dashboard-header">
      <div className="header-left">
        <button
          onClick={handleBack}
          title="Back"
          style={{
            display: 'flex',
            alignItems: 'center',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#5f6675',
            fontSize: '22px',
            lineHeight: 1,
            padding: '4px 10px 4px 4px',
            borderRadius: '8px',
            marginRight: '2px',
            flexShrink: 0,
          }}
        >
          ←
        </button>
        <div className="logo" onClick={() => navigate('/home')}>
          Dashboard
        </div>
        
        {/* Move all 4 buttons to header-left for perfect alignment */}
        <div className="header-buttons">
          {/* Search button with tooltip */}
          <div 
            className="home-button tooltip-container" 
            onClick={() => navigate('/')}
            title={t.search}
          >
            <i className="fas fa-search"></i>
            <span className="search-icon">🔍</span>
            <div className="tooltip">{t.search}</div>
          </div>
          
          {/* Tour Guide button with tooltip */}
          <div 
            className="tour-guide-button tooltip-container" 
            onClick={() => navigate('/tour-guide', { state: { from: '/dashboard' } })}
            title={t.groupTracking}
          >
            <span className="compass-people-icon">🧭👥</span>
            <div className="tooltip">{t.groupTracking}</div>
          </div>
          
          {/* Notification Dropdown */}
          <NotificationDropdown user={user} />
          
          <div className="profile-section">
            <div className="profile-button" onClick={() => setShowProfileMenu(!showProfileMenu)}>
              {user.avatar_url ? (
                <img 
                  src={user.avatar_url} 
                  alt="Profile" 
                  className="profile-image" 
                />
              ) : (
                <div className="profile-avatar-fallback">
                  <span className="avatar-letter">{user.name ? user.name.charAt(0).toUpperCase() : 'U'}</span>
                </div>
              )}
              <span className="profile-name">{user.name}</span>
            </div>
            
            {showProfileMenu && (
              <div ref={profileMenuRef}>
                <ProfileMenu
                  user={user}
                  requestPending={requestPending}
                  handleArtistRequest={handleArtistRequest}
                  handleVenueOwnerRequest={handleVenueOwnerRequest}
                  handleLogout={handleLogout}
                  navigate={navigate}
                  language={language}
                  onLanguageChange={onLanguageChange} // ← FIX: Pass the callback
                />
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* header-right can be empty or used for other elements */}
      <div className="header-right">
        {/* Empty for now, or can be used for additional elements */}
      </div>
    </header>
  );
};

export default HeaderComponent;
